import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { HeaderDto } from '../../dto/header.dto';
import { renderAsync } from 'docx-preview';
import * as Sentry from '@sentry/angular';
import { FilesHelperService } from '../../services/files-helper.service';

const DOCX_MIME_TYPE =
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

@Component({
  selector: 'app-expeditor-terms',
  templateUrl: './expeditor-terms.component.html',
  styleUrls: ['./expeditor-terms.component.css']
})
export class ExpeditorTermsComponent implements OnInit {
  @ViewChild('docxContainer', { static: true }) docxContainer!: ElementRef;
  headerDataValues: HeaderDto = {
    title: 'Договор экспедирования',
    downloadOption: true
  };

  private docxFilePath = '/assets/AppsDocs/teo2024.docx';
  private fileContent: ArrayBuffer | null = null;

  constructor(private readonly filesHelper: FilesHelperService) {}

  ngOnInit(): void {
    this.loadDocxFile(this.docxFilePath);
  }

  loadDocxFile(filePath: string): void {
    fetch(filePath)
      .then(response => response.arrayBuffer())
      .then(arrayBuffer => {
        this.fileContent = arrayBuffer;
        const container = this.docxContainer.nativeElement;
        renderAsync(arrayBuffer, container).catch(error => {
          Sentry.captureException(error);
        });
      })
      .catch(error => Sentry.captureException(error));
  }

  async onDownloadClicked(): Promise<void> {
    if (!this.fileContent) {
      return;
    }

    try {
      const fileName = 'expeditor_terms.docx';
      const blob = new Blob([this.fileContent], { type: DOCX_MIME_TYPE });
      // Сохраняем И открываем: на нативе прежде файл молча писался в песочницу без открытия/уведомления.
      await this.filesHelper.saveAndOpenFile(blob, fileName, DOCX_MIME_TYPE);
    } catch (error) {
      Sentry.captureException(error);
    }
  }
}
